import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../stylesheets';
import { Text, Icon } from '../';

type Props = {
  className?: string,
  receivedFrom: string,
  chatText: string,
  closeNotification: Function,
  viewChat: Function,
};

const StyledChatNotification = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 5px 10px;
  width: 300px;
  height: 70px;
  border-radius: 15px 15px 0 15px;
  background: ${colors.lightBlue};

  #chat-notification-text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .view-chat-notification-button {
    cursor: pointer;
  }

  .close-notification-container {
    width: 15%;
    height: 100%;
    position: absolute;
    top: 0;
    left: -15%;
    display: none;
    padding-top: 13px;
  }

  #close-notification-button {
    background: ${colors.lightBlue};
    width: 16px;
    height: 16px;
    border-radius: 8px;
    display: none;
  }

  &:hover {
    .close-notification-container {
      display: flex;
      justify-content: center;
    }
    #close-notification-button {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
`;

const ChatNotification = ({
  className,
  receivedFrom,
  chatText,
  closeNotification,
  viewChat,
}: Props) => {
  return (
    <StyledChatNotification className={className}>
      <div className="d-flex align-items-center justify-content-between w-100">
        <Text size="sm">{receivedFrom}</Text>
        <Text
          size="sm"
          color="blue"
          className="view-chat-notification-button"
          onClick={viewChat}
        >
          مشاهده
        </Text>
      </div>

      <Text size="xs" id="chat-notification-text">
        {chatText}
      </Text>

      <div className="close-notification-container">
        <Icon
          id="close-notification-button"
          size={9}
          color="blackText"
          name="e-remove"
          onClick={closeNotification}
        />
      </div>
    </StyledChatNotification>
  );
};

ChatNotification.defaultProps = {
  className: '',
};

export default ChatNotification;
